import SEOHead from '@/components/SEOHead'
import { blogPosts } from '@/data/blogPosts'
import { navigateTo } from '@/lib/hashRouter'
import {ArrowLeft} from 'lucide-react'

function BlogPost({ slug }: { slug: string }) {
  const post = blogPosts.find(p => p.slug === slug)

  if (!post) {
    return (
      <div className="max-w-3xl mx-auto px-4 py-24 text-center">
        <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-emerald-700">Article</p>
        <h1 className="mt-3 text-2xl font-extrabold text-slate-900 tracking-tight">Article not found</h1>
        <button onClick={() => navigateTo('/blog')} className="mt-4 text-emerald-700 font-semibold hover:underline">
          Back to Blog
        </button>
      </div>
    )
  }

  return (
    <div>
      <SEOHead title={post.title} description={post.excerpt} type="article" />
      <article className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <button
          onClick={() => navigateTo('/blog')}
          className="inline-flex items-center gap-1.5 text-[13px] font-semibold text-slate-500 hover:text-emerald-700 transition-colors mb-8"
        >
          <ArrowLeft className="w-4 h-4" />
          Back to Blog
        </button>

        <span className="text-[11px] font-semibold text-emerald-700 uppercase tracking-[0.14em]">{post.category}</span>
        <h1 className="mt-3 text-[1.75rem] sm:text-4xl font-extrabold text-slate-900 tracking-tight leading-tight">
          {post.title}
        </h1>
        <p className="mt-3 text-sm text-slate-400">{post.readTime}</p>

        <div className="mt-8 bg-white border border-slate-200 rounded-2xl p-6 sm:p-8 space-y-5 shadow-[0_1px_2px_rgba(15,23,42,0.04)]">
          {post.content.map((paragraph, i) => (
            <p
              key={i}
              className="text-[15px] text-slate-600 leading-relaxed"
              dangerouslySetInnerHTML={{ __html: paragraph }}
            />
          ))}
        </div>
      </article>
    </div>
  )
}

export default BlogPost
